import axios from 'axios';

export function getPermissions() {
  return axios.get('/api/v2/permissions/me');
}
